<template>
  <div id="app">
    <Alert />
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>
<script>
import MainLayout from "@/layouts/MainLayout";
import AuthLayout from "@/layouts/AuthLayout";
import UserLayout from "@/layouts/UserLayout";
import LessonLayout from "@/layouts/LessonLayout";
import Alert from "@/components/Alert";
export default {
  title: "Asosiy",
  data() {
    return {
      active: false,
    };
  },
  created() {
    // Set initial i18n locale from store
    const storedLang = localStorage.getItem("cl") || "lat2cyr";
    this.$i18n.locale = storedLang;
  },
  async mounted() {
    const params = new URLSearchParams(window.location.search);
    if (params.get("referrer")) {
      localStorage.setItem("referrer", params.get("referrer"));
    } else {
      localStorage.removeItem("referrer");
    }
    if (localStorage.getItem("access")) {
      try {
        await Promise.all([
          this.$store.dispatch("getUserCredentials"),
          this.$store.dispatch("getWishlist"),
          this.$store.dispatch("notificationList"),
        ]);
      } catch (e) {
        console.error("Failed to load user data:", e);
      }
    }
  },

  computed: {
    layout() {
      return (this.$route.meta.layout || "main") + "-layout";
    },
  },
  methods: {
    popupUser(e) {
      this.active = e;
    },
  },
  components: {
    MainLayout,
    UserLayout,
    AuthLayout,
    Alert,
    LessonLayout,
  },
};
</script>
